import React, { Component } from "react";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Button from "@material-ui/core/Button";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import { withStyles } from "@material-ui/core/styles";
import { withTranslation } from "react-i18next";
import { getErrorString } from "../display/ErrorStrings";
import PopupMessage from "../components/PopupMessage";

import SaveIcon from "@material-ui/icons/SaveOutlined";

const styles = (theme) => ({
  root: {
    width: "100%",
    marginTop: theme.spacing.unit * 3,
  },
  redCell: {
    color: "red",
  },
  spacer: {
    flex: "1 1 100%",
  },
  table: {
    border: "1px solid black",
    margin: "20px",
    width: 700,
  },
  paper: {
    height: 600,
    width: "100%",
    marginTop: theme.spacing.unit * 3,
    overflow: "auto",
  },
});

class HomePagePreferences extends Component {
  constructor(props) {
    super(props);
    this.state = {
      errorString: "",
      saveError: "",
      notifyString: "",
      checkSuspects: false,
      achSuspects: false,
      includeReports: false,
      accounts: [],
      reports: [],
      companyReports: [],
      includeCompanyReports: false,
      includeSearch: false,
      allCompanyReports: false,
      allAccounts: false,
      allReports: false,
      saving: false,
    };
    this.onClosePopup = this.onClosePopup.bind(this);
  }

  onClosePopup(e) {
    this.setState({ saveError: "" });
    this.setState({ notifyString: "" });
  }

  componentDidMount() {
    this.props.prefs.secureToken = this.props.secureToken;
    fetch("on_preferences_entry", {
      method: "POST",
      credentials: "same-origin",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(this.props.prefs),
    })
      .then(function (res) {
        if (!res.ok) {
          throw Error(res.status + " (" + res.statusText + ")");
        }
        return res;
      })
      .then((res) => res.text())
      .then((text) => {
        var reply = JSON.parse(text);
        if (reply.authenticated === false) {
          this.props.history.push("/expired");
        } else if (reply.error) {
          this.setState({ errorString: reply.errorString });
        } else {
          this.setState({ checkSuspects: reply.checkSuspects });
          this.setState({ achSuspects: reply.achSuspects });
          this.setState({ includeSearch: reply.search });
          this.setState({ accounts: reply.accounts });
          this.setState({ reports: reply.reports });
          this.setState({ companyReports: reply.companyReports });
          this.setState({ includeReports: this.props.prefs.reports });
          this.setState({
            includeCompanyReports: this.props.prefs.companyReports,
          });
          this.setState({ includeSearch: this.props.prefs.search });
        }
      })
      .catch((error) => {
        this.setState({
          errorString:
            getErrorString(
              "general.server.status.error",
              "The server responded with a status of "
            ) + error.message,
        });
      });
  }

  handleCheckSuspects = (name) => (event) => {
    this.setState({ checkSuspects: event.target.checked });
  };

  handleAchSuspects = (name) => (event) => {
    this.setState({ achSuspects: event.target.checked });
  };

  handleSearch = (name) => (event) => {
    this.setState({ includeSearch: event.target.checked });
  };

  handleReports = (name) => (event) => {
    this.setState({ includeReports: event.target.checked });
  };

  handleAllReports = (name) => (event) => {
    let reports = this.state.reports;
    let i;
    for (i = 0; i < reports.length; i++) {
      reports[i].included = event.target.checked;
    }
    this.setState({ reports: reports });
    this.setState({ allReports: event.target.checked });
  };

  handleReport = (index) => (event) => {
    let reports = this.state.reports;
    reports[index - 1].included = event.target.checked;
    this.setState({ reports: reports });
  };

  handleCompanyReports = (name) => (event) => {
    this.setState({ includeCompanyReports: event.target.checked });
  };

  handleAllCompanyReports = (name) => (event) => {
    let reports = this.state.companyReports;
    let i;
    for (i = 0; i < reports.length; i++) {
      reports[i].included = event.target.checked;
    }
    this.setState({ companyReports: reports });
    this.setState({ allCompanyReports: event.target.checked });
  };

  handleCompanyReport = (index) => (event) => {
    let reports = this.state.companyReports;
    reports[index - 1].included = event.target.checked;
    this.setState({ companyReports: reports });
  };

  handleAllAccounts = (name) => (event) => {
    let accounts = this.state.accounts;
    let i;
    for (i = 0; i < accounts.length; i++) {
      accounts[i].active = event.target.checked;
    }
    this.setState({ accounts: accounts });
    this.setState({ allAccounts: event.target.checked });
  };

  handleAccount = (index) => (event) => {
    let accounts = this.state.accounts;
    accounts[index - 1].active = event.target.checked;
    this.setState({ accounts: accounts });
  };

  handleSave(e) {
    if (this.props.viewOnly) {
      this.setState({
        saveError: getErrorString(
          "viewOnly.warning",
          "Operation not allowed in support mode."
        ),
      });
      return;
    }
    let i;
    if (this.state.includeReports) {
      let reportIncluded = false;
      let reports = this.state.reports;
      for (i = 0; i < reports.length; i++) {
        if (reports[i].included) {
          reportIncluded = true;
          break;
        }
      }
      if (!reportIncluded) {
        this.setState({ saveError: "At least one Account Report is required" });
        return;
      }
    }

    if (this.state.includeCompanyReports) {
      let companyReportIncluded = false;
      let companyReports = this.state.companyReports;
      for (i = 0; i < companyReports.length; i++) {
        if (companyReports[i].included) {
          companyReportIncluded = true;
          break;
        }
      }
      if (!companyReportIncluded) {
        this.setState({ saveError: "At least one Company Report is required" });
        return;
      }
    }

    if (
      this.state.includeReports ||
      this.state.includeCompanyReports ||
      this.state.includeSearch ||
      this.state.checkSuspects ||
      this.state.achSuspects
    ) {
      let accountIncluded = false;
      let accounts = this.state.accounts;
      for (i = 0; i < accounts.length; i++) {
        if (accounts[i].active) {
          accountIncluded = true;
          break;
        }
      }
      if (!accountIncluded) {
        this.setState({ saveError: "At least one Account is required" });
        return;
      }
    }

    this.setState({ saving: true });
    fetch("on_preferences_save", {
      method: "POST",
      credentials: "same-origin",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        checkSuspects: this.state.checkSuspects,
        achSuspects: this.state.achSuspects,
        accounts:
          this.state.includeReports ||
          this.state.includeCompanyReports ||
          this.state.includeSearch ||
          this.state.checkSuspects ||
          this.state.achSuspects
            ? this.state.accounts
            : [],
        reports: this.state.includeReports ? this.state.reports : [],
        companyReports: this.state.includeCompanyReports
          ? this.state.companyReports
          : [],
        search: this.state.includeSearch,
        includeReports: this.state.includeReports,
        includeCompanyReports: this.state.includeCompanyReports,
        secureToken: this.props.secureToken,
      }),
    })
      .then(function (res) {
        if (!res.ok) {
          throw Error(res.status + " (" + res.statusText + ")");
        }
        return res;
      })
      .then((res) => res.text())
      .then((text) => {
        var reply = JSON.parse(text);
        if (!reply.authenticated) {
          this.props.history.push("/expired");
        } else {
          this.setState({ saving: false });
          if (reply.error) {
            this.setState({ saveError: reply.errorString });
          } else {
            this.setState({ notifyString: "The changes have been saved" });
            this.props.onPrefChange(reply.preferences);
          }
        }
      })
      .catch((error) => {
        this.setState({
          errorString:
            getErrorString(
              "general.server.status.error",
              "The server responded with a status of "
            ) + error.message,
        });
        this.setState({ saving: false });
      });
  }

  render() {
    const { classes } = this.props;
    let reports = this.state.reports;
    let companyReports = this.state.companyReports;
    let accounts = this.state.accounts;
    let { t } = this.props;
    return (
      <div>
        {this.state.saveError.length > 0 && (
          <PopupMessage
            title={getErrorString("general.error", "Error")}
            text={this.state.saveError}
            error={true}
            onClosePopup={this.onClosePopup}
          />
        )}
        {this.state.notifyString.length > 0 && (
          <PopupMessage
            title="Information"
            text={this.state.notifyString}
            error={false}
            onClosePopup={this.onClosePopup}
          />
        )}
        <div>
          {this.state.errorString.length > 0 && (
            <Typography variant="h6" color="error">
              {this.state.errorString}
            </Typography>
          )}

          {this.state.errorString.length === 0 && (
            <div style={{ margin: 20 }}>
              <Typography variant="h6" color="primary">
                {t("homePreference.label")} &nbsp;&nbsp;
                <Button
                  color="primary"
                  onClick={(event) => this.handleSave(event)}
                  disabled={this.state.saving}
                >
                  <SaveIcon />
                  &nbsp;{t("saveChanges.button")}
                </Button>
              </Typography>
              <Paper>
                {!this.props.uiExclusionsList.includes("CHECKS") && (
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={this.state.checkSuspects === true}
                        onChange={this.handleCheckSuspects("checkS")}
                        disabled={
                          this.props.prefs.enableCheckSuspects === false &&
                          this.state.checkSuspects === false
                        }
                        value="checkS"
                        color="default"
                      />
                    }
                    label={t("checkSuspects.button")}
                  />
                )}
                {!this.props.uiExclusionsList.includes("ACH") && (
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={this.state.achSuspects === true}
                        onChange={this.handleAchSuspects("achS")}
                        disabled={
                          this.props.prefs.enableAchSuspects === false &&
                          this.state.achSuspects === false
                        }
                        value="achS"
                        color="default"
                      />
                    }
                    label={t("achSuspects.button")}
                  />
                )}
                {!this.props.uiExclusionsList.includes("SEARCH") && (
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={this.state.includeSearch === true}
                        onChange={this.handleSearch("search")}
                        value="search"
                        color="default"
                      />
                    }
                    label={t("itemSearch.label")}
                  />
                )}
                {!this.props.uiExclusionsList.includes("REPORTS") && (
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={this.state.includeReports === true}
                        onChange={this.handleReports("reports")}
                        value="reports"
                        color="default"
                      />
                    }
                    label={t("accountReports.label")}
                  />
                )}
                {!this.props.uiExclusionsList.includes("REPORTS") && (
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={this.state.includeCompanyReports === true}
                        onChange={this.handleCompanyReports("reports")}
                        value="company_reports"
                        color="default"
                      />
                    }
                    label={t("companyReports.label")}
                  />
                )}
              </Paper>
              <Paper className={classes.paper}>
                {this.state.includeReports &&
                  !this.props.uiExclusionsList.includes("REPORTS") && (
                    <div style={{ marginTop: 20 }}>
                      <Typography variant="h6" color="primary">
                        {t("preferredAcctReports.label")}
                      </Typography>
                      <Paper>
                        <Table>
                          <TableHead>
                            <TableRow>
                              <TableCell width="10%">
                                <Checkbox
                                  checked={this.state.allReports === true}
                                  onChange={this.handleAllReports("allReports")}
                                  value="allReports"
                                  color="default"
                                />
                              </TableCell>
                              <TableCell style={{ fontWeight: 600 }}>
                                {" "}
                                {t("reportType.label")}{" "}
                              </TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {reports.map((item) => {
                              return (
                                <TableRow key={item.index}>
                                  <TableCell>
                                    <Checkbox
                                      checked={item.included === true}
                                      onChange={this.handleReport(item.index)}
                                      value={item.index}
                                      color="default"
                                    />
                                  </TableCell>
                                  <TableCell>{item.description}</TableCell>
                                </TableRow>
                              );
                            })}
                          </TableBody>
                        </Table>
                      </Paper>
                    </div>
                  )}

                {this.state.includeCompanyReports &&
                  !this.props.uiExclusionsList.includes("REPORTS") && (
                    <div style={{ marginTop: 20 }}>
                      <Typography variant="h6" color="primary">
                        {t("preferredCompReports.label")}
                      </Typography>
                      <Paper>
                        <Table>
                          <TableHead>
                            <TableRow>
                              <TableCell width="10%">
                                <Checkbox
                                  checked={
                                    this.state.allCompanyReports === true
                                  }
                                  onChange={this.handleAllCompanyReports(
                                    "allReports"
                                  )}
                                  value="allCompanyReports"
                                  color="default"
                                />
                              </TableCell>
                              <TableCell style={{ fontWeight: 600 }}>
                                {" "}
                                {t("reportType.label")}{" "}
                              </TableCell>
                              <TableCell style={{ fontWeight: 600 }}>
                                {" "}
                                {t("notes.label")}{" "}
                              </TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {companyReports.map((item) => {
                              return (
                                <TableRow key={item.index}>
                                  <TableCell>
                                    <Checkbox
                                      checked={item.included === true}
                                      onChange={this.handleCompanyReport(
                                        item.index
                                      )}
                                      value={item.index}
                                      color="default"
                                    />
                                  </TableCell>
                                  <TableCell>{item.description}</TableCell>
                                  <TableCell>{item.notes}</TableCell>
                                </TableRow>
                              );
                            })}
                          </TableBody>
                        </Table>
                      </Paper>
                    </div>
                  )}
                {(this.state.checkSuspects ||
                  this.state.achSuspects ||
                  this.state.includeReports ||
                  this.state.includeCompanyReports ||
                  this.state.includeSearch) && (
                  <div style={{ marginTop: 20 }}>
                    <Typography variant="h6" color="primary">
                      {t("preferredAccounts.label")}
                    </Typography>
                    <Paper>
                      <Table>
                        <TableHead>
                          <TableRow>
                            <TableCell width="10%">
                              <Checkbox
                                checked={this.state.allAccounts === true}
                                onChange={this.handleAllAccounts("allAccounts")}
                                value="allAccounts"
                                color="default"
                              />
                            </TableCell>
                            <TableCell width="20%" style={{ fontWeight: 600 }}>
                              {" "}
                              {t("transit.header")}{" "}
                            </TableCell>
                            <TableCell style={{ fontWeight: 600 }}>
                              {" "}
                              {t("account.header")}{" "}
                            </TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {accounts.map((item) => {
                            return (
                              <TableRow key={item.key}>
                                <TableCell>
                                  <Checkbox
                                    checked={item.active === true}
                                    onChange={this.handleAccount(item.key)}
                                    value={item.key}
                                    color="default"
                                  />
                                </TableCell>
                                <TableCell>{item.transit}</TableCell>
                                <TableCell>{item.account}</TableCell>
                              </TableRow>
                            );
                          })}
                        </TableBody>
                      </Table>
                    </Paper>
                  </div>
                )}
              </Paper>
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default withTranslation()(withStyles(styles)(HomePagePreferences));
